import React from 'react';
import { component_tool } from '@/tool'
let { WizRadio, WizInputNumber, WizRow, WizCol, WizTooltip, WizIcon, WizInput } = component_tool

// 水印形式改变时,更改对应的字段名称
const otherRow = (key, initVal) => {
  let jsonInfo = [
    {
      title: `${key === 0 ? '行数' : '距离顶部'}`,
      name: 'h',
      formItem: {
        type: 'custom',
        render: (record, form) => {
          const { getFieldDecorator } = form
          return (
            <WizRow>
              <WizCol span={20}>
                {
                  getFieldDecorator('shapeX', {
                    initialValue: initVal?.shapeX || '',
                  })(
                    <WizInput placeholder={`请输入${key === 0 ? '行数' : '距离顶部位置'}`} />
                  )
                }
              </WizCol>
              <WizCol span={1}>
                <WizTooltip title={`${key === 0 ? '水印行数' : '水印距离顶部位置'}`}>
                  <WizIcon type='question-circle-o' style={{ marginLeft: 10 }} />
                </WizTooltip>
              </WizCol>
            </WizRow>
          )
        }
      }
    },
    {
      title: `${key === 0 ? '列数' : '距离左侧'}`,
      name: 'l',
      formItem: {
        type: 'custom',
        render: (record, form) => {
          const { getFieldDecorator } = form
          return (
            <WizRow>
              <WizCol span={20}>
                {
                  getFieldDecorator('shapeY', {
                    initialValue: initVal?.shapeY || '',
                  })(
                    <WizInput placeholder={`请输入${key === 0 ? '列数' : '距离左侧位置'}`} />
                  )
                }
              </WizCol>
              <WizCol span={1}>
                <WizTooltip title={`${key === 0 ? '水印列数' : '水印距离左侧位置'}`}>
                  <WizIcon type='question-circle-o' style={{ marginLeft: 10 }} />
                </WizTooltip>
              </WizCol>
            </WizRow>
          )
        }
      }
    },
  ]

  return jsonInfo
}

// 一些tip提示信息
// 自定义样式属性提示
const tipToStyle = () => {
  return (
    <>
      <p>自定义水印样式</p>
      <p>需要通过{' {} '}进行包裹</p>
      <p>{`如：{color:'red',opacity:0.5}`},具体参考css编码规则 </p>
    </>
  )
}

// 水印角度提示
const tipToAngle = '用于设置水印内容的倾斜角度,取值 ±360'


// 水印内容提示
const tipToContent = () => {
  return (
    <>
      <p>水印展示的内容</p>
      <p>{`如为固定文字,直接编写即可,通过<br/>可进行换行`}</p>
      <p>提供了一些参数,可通过'{'{xxx}'}'进行获取具体参数</p>
      <p>{`参数示例: fullName 姓名、username 账号、dealerName 经销商名称 `}</p>
    </>
  )
}


export default (self, initialValue) => {
  let { watermarkType } = self.state
  return [
    {
      name: 'id',
      formItem: {
        type: 'hidden',
        initialValue: initialValue?.id,
      }
    },
    {
      title: '适用终端',
      name: 'platform',
      dataIndex: 'platform',
      formItem: {
        initialValue: initialValue?.platform || 0,
        rules: [{ required: true, message: '请选择端' }],
        type: 'radio',
      },
      dict: [
        { code: '0', codeName: 'PC管理端' },
        { code: '1', codeName: 'PC学员端' },
        { code: '2', codeName: 'APP' },
        // {code: 2, codeName: '企业号'},
        // {code: 3, codeName: '小程序'},
        { code: '8', codeName: 'PDF' },
      ]
    },
    {
      title: '水印类型',
      name: 'type',
      dataIndex: 'type',
      formItem: {
        initialValue: initialValue?.type || 0,
        rules: [{ required: true, message: '请选择类型' }],
        type: 'radio',
      },
      dict: [
        { code: 0, codeName: '网页' },
        { code: 1, codeName: 'PDF' },
      ]
    },
    {
      title: '水印形式',
      name: 'shape',
      formItem: {
        type: 'custom',
        render: (record, form) => {
          const { getFieldDecorator, setFieldsValue } = form;
          const radioChange = (val) => {
            self.setState({
              watermarkType: val
            })
            setFieldsValue({
              shapeX: '',
              shapeY: ''
            });
          }
          return (
            <div>
              {
                getFieldDecorator('shape', {
                  initialValue: initialValue.shape ? initialValue.shape : 0,
                  rules: [
                    { required: true, message: '请选择水印形式' },
                  ],
                })(
                  <WizRadio.Group onChange={(e) => { radioChange(e.target.value) }} >
                    <WizRadio value={0}>
                      平铺
                      <WizTooltip title={'通过设置行数与列数渲染出对应数量的水印'}>
                        <WizIcon type='question-circle-o' style={{ marginLeft: 10 }} />
                      </WizTooltip>
                    </WizRadio>
                    <WizRadio value={1}>
                      定位
                      <WizTooltip title={'通过设置位置,在指定区域渲染水印'}>
                        <WizIcon type='question-circle-o' style={{ marginLeft: 10 }} />
                      </WizTooltip>
                    </WizRadio>
                  </WizRadio.Group>
                )
              }
            </div>
          )
        }
      }
    },
    ...otherRow(watermarkType, initialValue),
    {
      title: '水印内容',
      name: 'content',
      formItem: {
        type: 'custom',
        render: (record, form) => {
          const { getFieldDecorator } = form
          return (
            <WizRow>
              <WizCol span={20}>
                {
                  getFieldDecorator('content', {
                    rules: [{ required: true, message: '请输入水印内容' }],
                    initialValue: initialValue?.content || ''
                  })(
                    <WizInput placeholder='请输入水印内容' />
                  )
                }
              </WizCol>
              <WizCol span={1}>
                <WizTooltip title={tipToContent()}>
                  <WizIcon type='question-circle-o' style={{ marginLeft: 10 }} />
                </WizTooltip>
              </WizCol>
            </WizRow>
          )
        }
      }
    },
    {
      title: '水印角度',
      name: 'angle',
      formItem: {
        type: 'custom',
        render: (record, form) => {
          const { getFieldDecorator } = form;
          return (
            <WizRow>
              <WizCol span={20}>
                {
                  getFieldDecorator('angle', {
                    rules: [{ required: true, message: '请输入水印角度' }],
                    initialValue: initialValue.angle || initialValue.angle === 0 ? initialValue.angle  : ''
                  })(
                    <WizInputNumber
                      maxlength={360}
                      min={-360}
                      defaultValue={initialValue?.angle}
                      placeholder='请输入水印角度'
                    />
                  )
                }
              </WizCol>
              <WizCol span={1}>
                <WizTooltip title={tipToAngle}>
                  <WizIcon type='question-circle-o' style={{ marginLeft: 10 }} />
                </WizTooltip>
              </WizCol>
            </WizRow>
          )
        }
      }
    },
    {
      title: '水印颜色',
      name: 'color',
      formItem: {
        type: 'custom',
        render: (record, form) => {
          const { getFieldDecorator } = form
          return (
            <WizRow>
              <WizCol span={20}>
                {
                  getFieldDecorator('color', {
                    rules: [{ required: true, message: '请输入水印颜色' }],
                    initialValue: initialValue?.color || '#000000'
                  })(
                    <WizInput style={{width:'100px'}} placeholder='请输入水印颜色' type='color' />
                  )
                }
              </WizCol>
              <WizCol span={1}>
                <WizTooltip title={'水印颜色'}>
                  <WizIcon type='question-circle-o' style={{ marginLeft: 10 }} />
                </WizTooltip>
              </WizCol>
            </WizRow>
          )
        }
      }
    },
    {
      title: '水印透明度',
      name: 'opacity',
      formItem: {
        type: 'custom',
        render: (record, form) => {
          const { getFieldDecorator } = form
          return (
            <WizRow>
              <WizCol span={20}>
                {
                  getFieldDecorator('opacity', {
                    rules: [{ required: true, message: '请输入水印透明度' }],
                    initialValue: initialValue.opacity || initialValue.opacity === 0 ? initialValue.opacity : 0.5
                  })(
                    <WizInputNumber min={0} max={1} step={0.1} placeholder='请输入水印透明度,0~1,为1时不透明' />
                  )
                }
              </WizCol>
              <WizCol span={1}>
                <WizTooltip title={'水印透明度'}>
                  <WizIcon type='question-circle-o' style={{ marginLeft: 10 }} />
                </WizTooltip>
              </WizCol>
            </WizRow>
          )
        }
      }
    },
    {
      title: '水印字体大小',
      name: 'fontSize',
      formItem: {
        type: 'custom',
        render: (record, form) => {
          const { getFieldDecorator } = form
          return (
            <WizRow>
              <WizCol span={20}>
                {
                  getFieldDecorator('fontSize', {
                    rules: [{ required: true, message: '请输入水印字体大小' }],
                    initialValue: initialValue?.fontSize || ''
                  })(
                    <WizInput placeholder='请输入水印字体大小' />
                  )
                }
              </WizCol>
              <WizCol span={1}>
                <WizTooltip title={'水印字体大小,如:16px、20px'}>
                  <WizIcon type='question-circle-o' style={{ marginLeft: 10 }} />
                </WizTooltip>
              </WizCol>
            </WizRow>
          )
        }
      }
    },
    {
      title: '自定义样式属性',
      name: 'customAttribute',
      formItem: {
        type: 'custom',
        render: (record, form) => {
          const { getFieldDecorator } = form;
          return (
            <WizRow>
              <WizCol span={20}>
                {
                  getFieldDecorator('customAttribute', {
                    initialValue: initialValue?.customAttribute || ''
                  })(
                    <WizInput.TextArea
                      maxlength={360}
                      min={-360}
                      defaultValue={initialValue?.customAttribute}
                      placeholder='请输入自定义样式属性'
                    />
                  )
                }
              </WizCol>
              <WizCol span={1}>
                <WizTooltip title={tipToStyle()}>
                  <WizIcon type='question-circle-o' style={{ marginLeft: 10 }} />
                </WizTooltip>
              </WizCol>
            </WizRow>
          )
        }
      },
    },
    {
      title: '用户属性',
      name: 'scope',
      dict: [
        { code: 0, codeName: "培训平台用户" },
        { code: 5, codeName: "服务商用户" },
        { code: 4, codeName: "经销商用户" },
        { code: 3, codeName: "OEM部门用户" }
        // { code: 5, codeName: 'FSE' }
      ],
      formItem: {
        initialValue: initialValue?.scopeInfo,
        type: 'checkbox',
      }
    },
    {
      title: '状态',
      name: 'state',
      dataIndex: 'state',
      formItem: {
        initialValue: initialValue?.state === 0 ? 0 : 1,
        type: 'radio'
      },
      dict: [
        { code: 1, codeName: '启用' },
        { code: 0, codeName: '禁用' }
      ]
    },
  ]
}
